import {captureError} from '../integrations';

/**
 * Reports a key with an unhandled `section` and returns the error to throw. The
 * thrown message stays constant so Error Tracking keeps its existing grouping.
 * The key's `name` is left out because it is user data.
 */
export function unsupportedKeySectionError(
  converter: string,
  key: {section?: unknown}
): Error {
  const error = new Error('keyToServerPath error');
  captureError(error, converter, {
    extra: {unsupportedKeySection: String(key?.section)},
  });
  return error;
}
